import React, { useEffect, useState } from "react";
import axios from "axios";
import { Alert, Button, Spinner } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { useTranslation } from "react-i18next";

const UserMessages = () => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [marking, setMarking] = useState({});
    const { user } = useAuth();
    const userId = user?.id;
    const { t } = useTranslation();

    const fetchMessages = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const res = await axios.get(`/api/messages/${userId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setMessages(res.data);

            // автоматичне позначення opened_at
            res.data
                .filter((msg) => !msg.opened_at && !msg.read_at)
                .forEach((msg) => {
                    axios
                        .post(
                            `/api/mark-message`,
                            {
                                message_id: msg.id,
                                driver_id: userId,
                                action: "opened",
                                device_info: navigator.userAgent,
                            },
                            {
                                headers: { Authorization: `Bearer ${token}` },
                            }
                        )
                        .catch((err) => console.error("❌ Не вдалося позначити як opened:", err));
                });
        } catch (err) {
            console.error("Помилка при отриманні повідомлень:", err);
        } finally {
            setLoading(false);
        }
    };

    const markAsRead = async (msgId) => {
        try {
            setMarking((prev) => ({ ...prev, [msgId]: true }));
            const token = localStorage.getItem("token");

            await axios.post(
                `/api/mark-message`,
                {
                    message_id: msgId,
                    driver_id: userId,
                    action: "read",
                    device_info: navigator.userAgent,
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            fetchMessages();
        } catch (err) {
            console.error("Помилка при оновленні статусу:", err);
        } finally {
            setMarking((prev) => ({ ...prev, [msgId]: false }));
        }
    };

    const getAlertClass = (importance) => {
        switch (importance) {
            case "danger":
                return "danger";
            case "warning":
                return "warning";
            case "success":
                return "success";
            case "info":
            default:
                return "primary";
        }
    };

    useEffect(() => {
        if (userId) fetchMessages();
    }, [userId]);

    return (
        <div className="container mt-3">
            <h5>{t("yourMessages")}</h5>
            {loading ? (
                <Spinner animation="border" />
            ) : messages.length === 0 ? (
                <p className="text-muted">{t("noMessages")}</p>
            ) : (
                messages.map((msg) => (
                    <Alert
                        key={msg.id}
                        variant={getAlertClass(msg.importance)}
                        className="position-relative"
                    >
                        <div className="d-flex justify-content-between align-items-start mb-1">
                            <strong>{msg.title}</strong>
                            <small className="text-muted" style={{ whiteSpace: "nowrap" }}>
                                {new Date(msg.created_at).toLocaleString()}
                            </small>
                        </div>

                        <div className="mb-2" dangerouslySetInnerHTML={{ __html: msg.content }} />

                        {(msg.read_at || msg.opened_at) && (
                            <div className="text-muted small mb-2">
                                {msg.read_at ? (
                                    <>✅ {t("read")}: {new Date(msg.read_at).toLocaleString()}</>
                                ) : (
                                    <>📖 {t("opened")}: {new Date(msg.opened_at).toLocaleString()}</>
                                )}
                            </div>
                        )}

                        <div className="d-flex justify-content-between align-items-center mt-2">
                            <span
                                className={`badge px-2 py-1 rounded-pill fw-normal ${msg.is_global
                                    ? "bg-primary-subtle text-primary"
                                    : "bg-purple-subtle text-dark"
                                    }`}
                                style={{
                                    fontSize: "0.8rem",
                                    backgroundColor: msg.is_global ? "#e7f1ff" : "#f2e8ff",
                                    color: msg.is_global ? "#0d6efd" : "#6f42c1",
                                    border: "1px solid transparent",
                                }}
                            >
                                {msg.is_global ? t("messageTypeGlobal") : t("messageTypePersonal")}
                            </span>

                            {msg.read_at ? (
                                <span className="badge bg-success">{t("markAsRead")}</span>
                            ) : (
                                <Button
                                    size="sm"
                                    variant="outline-dark"
                                    className="fw-semibold px-3 py-1"
                                    style={{ fontSize: "0.85rem" }}
                                    disabled={marking[msg.id]}
                                    onClick={() => markAsRead(msg.id)}
                                >
                                    {marking[msg.id] ? "..." : `✓ ${t("markAsRead")}`}

                                </Button>


                            )}
                        </div>
                    </Alert>
                ))
            )}
        </div>
    );
};

export default UserMessages;
